/* eslint-disable react/no-danger */
import React, { useState } from 'react';
import parse from 'html-react-parser';
import { Collapse } from 'reactstrap';
import { Title, Text, ShowMore, Block } from './styles';

export const SearchResult = props => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    data: { question, answer, answerPart1, answerPart2 },
  } = props;
  const toggle = () => setIsOpen(!isOpen);
  return (
    <Block xs="12" className="mb-4">
      <Title>
      { parse(question) }
      </Title>
      <Text>
        <span>{ parse(answerPart1 || answer) }</span>
        {answerPart2 ? (
          <Collapse isOpen={isOpen}>
            <span>{ parse(answerPart2) }</span>
          </Collapse>
        ) : null}
      </Text>
      {answerPart2 ? (
        <ShowMore onClick={toggle}>{`Show ${isOpen ? 'less' : 'more'}`}</ShowMore>
      ) : null}
    </Block>
  );
};
